
import { Vue, Component, Prop } from "vue-property-decorator";
import DrawOverlaysBD from "../../DrawOverlays/bd/DrawOverlaysBD";
import { OverlayBaidu } from "../../Overlays/bd/OverlayBaidu";
import WidgetsManagerBD from "./WidgetsManagerBD";
declare let BMap: any;
@Component
export default class Measurement extends Vue {
  @Prop({ type: Object }) map!: any;

  private menuList: string[] = ["标记", "测距", "测面", "删除", "搜索"];
  private menuIndex: number = -1;

  private menuFn(ind: number) {
    if (ind == 3) {
      this.menuIndex = -1;
    } else {
      this.menuIndex = ind;
    }
    if (ind == 4) {
      let tool = WidgetsManagerBD.getInstance(this.map);
      tool.toggleWidget(["search"]);
      this.measureTool("clear");
    } else if (ind == 3) {
      this.measureTool("clear");
    } else if (ind == 2) {
      this.measureTool("area");
    } else if (ind == 1) {
      this.measureTool("line");
    } else if (ind == 0) {
      this.addPoint();
    }
  }
  private async addPoint() {
    let draw = DrawOverlaysBD.getInstance(this.map);
    const results = draw.startDrawOverlays({
      defaultSymbol: {
        url: "assets/styles/img/marker.png",
        size: [40, 40],
        anchor: "top",
      },
      drawType: "point",
      type: "markPoint",
      clearLastResult: false,
      callback: false,
      onlyOnce: true,
    });
  }
  private async measureTool(type: string) {
    const drawOverlays = DrawOverlaysBD.getInstance(this.map);
    if (type == "line") {
      drawOverlays.polylineRanging();
    } else if (type == "area") {
      drawOverlays.deleteDrawOverlays({ types: ["measure"] });
      drawOverlays.startDrawOverlays({
        drawType: "polygon",
        type: "measure",
        enableCalculate: true,
        clearLastResult: true,
        onlyOnce: true,
      });
    } else if (type == "clear") {
      drawOverlays.deleteDrawOverlays({ types: ["measure", "markPoint"] });
      drawOverlays.stopDrawOverlays();
    }
  }
}
